import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";
import { StockReplenishmentRunDocLinkModel } from "../../../../../../models/aggregates/erp/stock/stock-replenishment-run-order-doc-link.model";
import { Observable } from "rxjs";
import { ApiVisa, ApiResponseModel } from "../../shared";

@Injectable({ providedIn: "root" })
export class StockReplenishmentRunDocLinkService extends BaseApiTemplateService<StockReplenishmentRunDocLinkModel> {
  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "stock-replenishment-run-doc-links/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "stock-replenishment-run-doc-links/backoffice-ep";
    this.httpClient = theHttp;
  }
}
